import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Wrapper } from '../styles';
import { Box } from '@/layout';
import { Text } from '@/components/UI/Typography/Text';
import { Button } from '@/components/UI/Button';
import { H5 } from '@/components/UI/Typography/Heading';
import { theme } from '@/theme/Theme';

interface FormStepperProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<string | null>>;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  applicationData: GoGlobalApplication;
}

const RegistrationStatus = ({ setCurrentStep, setActiveStep, applicationData }: FormStepperProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const statusArray = t('pages.eTrust.goGlobal.steps.step3.status', { returnObjects: true });
  const [status, setStatus] = useState<string>('pending');

  const prevHandler = () => {
    setCurrentStep('2');
    setActiveStep(1);
    setSearchParams({ step: '2' });
  };

  const nextHandler = () => {
    navigate('/home');
  };

  useEffect(() => {
    if (applicationData?.badge_record) {
      // status 可以是: "pending", "approved", "rejected"
      const badgeStatus = applicationData.status ?? 'pending';
      setStatus(badgeStatus);
    }
  }, [applicationData]);

  const checkStatusColor = (status: string) => {
    switch (status) {
      case 'pending':
        return theme.colors.yellow;
      case 'approved':
        return theme.colors.primary500;
      case 'rejected':
        return theme.colors.red;
      default:
        return theme.colors.gray200;
    }
  };

  const getStatusIndex = (status: string): number => {
    switch (status) {
      case 'pending':
        return 0;
      case 'approved':
        return 2;
      case 'rejected':
        return 6;
      default:
        return 0;
    }
  };

  return (
    <Wrapper>
      <Box marginBottom={100}>
        <H5 marginBottom={50}>
          {t('pages.eTrust.goGlobal.steps.step3.intro-top')}
          <br />
          {t('pages.eTrust.goGlobal.steps.step3.intro-bottom')}
        </H5>
        <div>
          <Text fontWeight={700} marginBottom={20}>
            {t('pages.eTrust.goGlobal.steps.step3.progress')}
          </Text>
          <Text fontWeight={700} color={checkStatusColor(status)}>
            ．{statusArray[getStatusIndex(status)]}
          </Text>
        </div>
      </Box>

      <Box style={{ paddingTop: 22 }}>
        {status === 'rejected' && (
          <Button size={'lg'} type="button" variant="primary" rounded={false} marginRight={40} onClick={prevHandler}>
            {t('buttons.refill')}
          </Button>
        )}
        {
          status !== 'rejected' && (
            <Button size={'lg'} type="button" variant={'primary'} rounded={false} marginRight={40} onClick={nextHandler}>
              {t('buttons.ok')}
            </Button>
          )
        }
      </Box>
    </Wrapper>
  );
};

export default RegistrationStatus;
